import gql from 'graphql-tag';

const untagResourceMutation = gql`
  mutation UntagResource($tagId: ID!, $resourceId: String!) {
    untagResource(tagId: $tagId, resourceId: $resourceId)
  }
`;

export default {
  mutation: untagResourceMutation,
  module: 'tags',
  isSilent: true,
  buildVariables: ({ tagId, assetId }) => ({
    tagId,
    resourceId: assetId
  })
};